import { createContext } from 'react';
export const initialContext = {
    customerSupportEmail: '',
    isDevMode: false,
};
const ErrorHandlingContext = createContext(initialContext);
export default ErrorHandlingContext;
